import ApiClient from 'api-client/ApiClient'
import ActionsSet from 'core/actions/ActionsSet'
import ListAction from 'core/actions/ListAction'
import DataKeys, { entityNamesByKey } from 'k8s/DataKeys'
import Bugsnag from 'utils/bugsnag'

const { kubernetes } = ApiClient.getInstance()

export const kaapiOpenstackMachineTemplateActions =
  ActionsSet.make<DataKeys.KaapiOpenStackMachineTemplates>({
    uniqueIdentifier: 'metadata.uid',
    entityName: entityNamesByKey[DataKeys.KaapiOpenStackMachineTemplates],
    cacheKey: DataKeys.KaapiOpenStackMachineTemplates,
  })

export const listkaapiOpenstackMachineTemplates = kaapiOpenstackMachineTemplateActions.add(
  new ListAction<DataKeys.KaapiOpenStackMachineTemplates, { namespace: string }>(
    async ({ namespace }) => {
      Bugsnag.leaveBreadcrumb('Attempting to list Kaapi OpenStackMachineTemplate', { namespace })
      return kubernetes.getAllCustomResources(DataKeys.KaapiOpenStackMachineTemplates)
    },
  ),
)
